import styled from 'styled-components';

const CallbackView = styled.section`
	width: 100%;
	height: 100vh;
`;

export default CallbackView;
